import BaseModelDirectInvestmentValuation from "@/models/BaseModelDirectInvestmentValuation.js";

export const GridConfig = {
	list: BaseModelDirectInvestmentValuation.list,
	// columns:BaseModelDirectInvestmentValuation.columns,
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			readOnly: false
		},
		PartnerId: {
			class: "lookup",
			dataName: 'PartnerId',
			type: 'number',
			title: 'Partner Id',
			width: 100,
			hidden: true,
			readOnly: false
		},
		PartnerPartnerID: {
			class: "lookup",
			dataName: 'Partner/PartnerID',
			type: 'string',
			title: 'Partner ID',
			width: 160,
			hidden: false,
			readOnly: true
		},
		PartnerFullName: {
			class: "lookup",
			dataName: 'Partner/FullName',
			type: 'string',
			title: 'Partner Name',
			width: 200,
			hidden: false,
			readOnly: true
		},
		InvestmentId: {
			class: "lookup",
			dataName: 'InvestmentId',
			type: 'number',
			title: 'Investment Id',
			width: 100,
			hidden: true,
			readOnly: false
		},
		InvestmentInvestmentID: {
			class: "lookup",
			dataName: 'Investment/InvestmentID',
			type: 'string',
			title: 'Investment ID',
			width: 180,
			hidden: false,
			readOnly: true
		},
		InvestmentTitle: {
			class: "lookup",
			dataName: 'Investment/Title',
			type: 'string',
			title: 'Investment Name',
			width: 210,
			hidden: false,
			readOnly: true
		},

		TaxYear: {
			class: "choice",
			dataName: 'TaxYear',
			type: 'string',
			title: 'Tax Year',
			width: 100,
			hidden: true,
			readOnly: false
		},
		TaxQuarter: {
			class: "choice",
			dataName: 'TaxQuarter',
			type: 'string',
			title: 'Tax Quarter',
			width: 100,
			hidden: true,
			readOnly: false
		},
		TaxYearQuarter: {
			class: "value",
			dataName: 'TaxYearQuarter',
			type: 'string',
			title: 'Tax Period',
			width: 150,
			hidden: true,
			readOnly: true
		},
		CommitmentFunded: {
			class: "value",
			dataName: 'CommitmentFunded',
			type: 'currency',
			title: 'Commitment Funded',
			template: '<span class="number-cell-ui">#=kendo.toString(CommitmentFunded, "c")#</span>',
			width: 220,
			hidden: false,
			readOnly: false
		},
		CommitmentRemaining: {
			class: "value",
			dataName: 'CommitmentRemaining',
			type: 'currency',
			title: 'Commitment Remaining',
			template: '<span class="number-cell-ui">#=kendo.toString(CommitmentRemaining, "c")#</span>',
			width: 240,
			hidden: false,
			readOnly: false
		},
		PriorCashDistribution: {
			class: "value",
			dataName: 'PriorCashDistribution',
			type: 'currency',
			title: 'Prior Cash Distribution',
			template: '<span class="number-cell-ui">#=kendo.toString(PriorCashDistribution, "c")#</span>',
			width: 240,
			hidden: false,
			readOnly: false
		},
		ProjectedValue: {
			class: "value",
			dataName: 'ProjectedValue',
			type: 'currency',
			title: 'Projected Value',
			template: '<span class="number-cell-ui">#=kendo.toString(ProjectedValue, "c")#</span>',
			width: 200,
			hidden: false,
			readOnly: false
		},
		CurrentValue: {
			class: "value",
			dataName: 'CurrentValue',
			type: 'currency',
			title: 'Current Value',
			template: '<span class="number-cell-ui">#=kendo.toString(CurrentValue, "c")#</span>',
			width: 200,
			hidden: false,
			readOnly: false
		},
		Note: {
			class: 'value',
			dataName: 'Note',
			type: 'string',
			title: 'Note',
			width: 100,
			hidden: true,
			readOnly: false
		},

	},
	grid: {
		gridId: 'DirectInvestmentGrid',
		height: 500,
		checkbox: true,
		edit: true,
		delete: false,
		document: false,
		groupable: true,
	}
}

export const ToolbarConfig = {
	list: 'ToolBarItems',
	items: [{
			template: `<Label style="width:110px;">Select Period: </Label>
				<div id="kendo-select"><input id="dropdownPeriodAllocation" style="width:120px;" /></div>`,
			overflow: "never"
			// template: `<Label style="width:200px;">Select Period: </Label>
			// <select id="dropdownPeriodAllocation" class="form-control">

			// </select>`, 

			// 	<kendo-dropdownlist id="dropdownPeriodAllocation"
			//             v-model="TaxPeriodDropdownValue"
			//             :data-source="TaxPeriodOptions"
			//             :data-text-field="'Option'"
			//             :data-value-field="'Option'">
			// </kendo-dropdownlist>

		},
		{
			id: "btnAddDirectInvestment",
			type: "button",
			text: "Add Valuation",
			showIcon: "toolbar",
			icon: "plus-circle",
			attributes: {
				"class": "float-right-btn btn btn-primary"
			},
		},
		{
			id: "btnBulkImportAllocation",
			type: "button",
			text: "Bulk Import",
			showIcon: "toolbar",
			icon: "upload",
			attributes: {
				"class": "float-right-btn btn btn-secondary"
			},

		},

	]
}